module.exports = __webpack_public_path__ + "img/sld_mfm_acb_ta1_b1.2cd140ed.svg";